import { render, staticRenderFns } from "./tab-confirm-customer.vue?vue&type=template&id=166f118e&"
import script from "./tab-confirm-customer.vue?vue&type=script&lang=js&"
export * from "./tab-confirm-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports